module.exports = __webpack_public_path__ + "img/banner-img.9fb392c8.png";